import { Controller } from "@hotwired/stimulus"
import setAttr from '../common/element'

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ['modal']

  connect() {
    document.querySelector('body').classList.add('no-scroll')
    // setAttr(document.getElementById("toolbar"), 'role', 'scrollable-toolbar')
    // document.getElementById("toolbar").setAttribute('role', 'scrollable-toolbar')
    // document.getElementById("modal").classList.add('bg-modal')
  }

  modalTargetConnected(element) {
    // $(element).show()
  }

  // hide modal
  // action: "modal#hideModal"
  hideModal() {
    console.log(this.element, this.element.parentElement)
    this.element.parentElement.removeAttribute("src")
    // Remove src reference from parent frame element
    // Without this, turbo won't re-open the modal on subsequent click
    this.modalTarget.remove()
    document.querySelector("body").classList.remove("no-scroll")
    // document.getElementById("toolbar").setAttribute("role", 'fixed-toolbar')
    // document.getElementById("modal").classList.remove('bg-modal')
    // document.querySelector("body").classList.remove("reveal-viewport");
    // document.querySelector("html").classList.remove("reveal-full-page");
  }

  // hide modal on successful form submission
  // action: "turbo:submit-end->modal#submitEnd"
  submitEnd(e) {
    console.log('================================================')
    console.log(e.detail.formSubmission.formElement.dataset);
    if (e.detail.success) {
      this.hideModal()
    }
  }

  // hide modal when clicking ESC
  // action: "keyup@window->modal#closeWithKeyboard"
  closeWithKeyboard(e) {
    if (e.code == "Escape") {
      this.hideModal()
    }
  }

  // hide modal when clicking outside of modal
  // action: "click@window->modal#closeBackground"
  closeBackground(e) {
    if (e.target.classList.contains('backdrop')) {
      this.hideModal()
    }
  }  
}
